import type { EventYear } from '../../types';
import miamiHeroImage from '../../../assets/images/AdobeStock_1393129687.webp';

import { agenda } from './agenda';
import { locations } from './locations';
import { logistics } from './logistics';
import { theme } from './theme';

export const event2025: EventYear = {
  meta: {
    year: 2025,
    title: 'Annual General Meeting',
    tagline: 'Join us in Miami for our Annual General Meeting',
    displayDate: 'November 3-4, 2025',
    city: 'Miami, Florida',
    venueName: 'W South Beach',
    heroImage: miamiHeroImage,
    isCurrent: false,
  },
  agenda,
  agendaNotes: [
    'Please arrive 15 minutes early for registration',
    'Light refreshments will be provided throughout the day',
    'All attendees must check in at registration',
    'Parking validation available at the front desk',
  ],
  locations,
  logistics,
  theme,
};
